import { library } from '@fortawesome/fontawesome-svg-core'
import { faComment, faStoreAlt, faBriefcase, faPlaneArrival } from '@fortawesome/free-solid-svg-icons'

library.add(faComment, faStoreAlt, faBriefcase, faPlaneArrival)